import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MergeSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MergeSVG;
